module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "20px  0 0 0"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Danielle")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#together-at-last"
    }
  }, [_vm._v("Together at Last")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#an-unexpected-joy"
    }
  }, [_vm._v("An Unexpected Joy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#our-hearts-are-so-full"
    }
  }, [_vm._v("Our Hearts Are So Full")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#growing-in-faith"
    }
  }, [_vm._v("Growing in Faith")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#then-there-were-two"
    }
  }, [_vm._v("Then There Were Two")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#going-home-a-family-of-five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going Home: A Family of Five")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#getting-settled-in-our-new-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Settled in Our New Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#valley-of-tears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valley of Tears")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#strength-to-endure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strength to Endure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#faith-hope-and-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith, Hope, and Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#growing-in-faith-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing in Faith")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-gift-from-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Gift from God")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#others-getting-to-know-danielle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Others Getting to Know Danielle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#other-setbacks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Setbacks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#summer-of-fun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer of Fun")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#relapse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relapse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#danielles-seventh-birthday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Danielle’s Seventh Birthday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#camp-watonga",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camp Watonga")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#sharing-in-the-eucharist-regularly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sharing in the Eucharist Regularly")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#finding-a-donor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding a Donor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#another-means-of-suffering",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Means of Suffering")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#a-perfect-match",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Perfect Match")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#come-holy-spirit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come Holy Spirit")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#trip-to-disney-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trip to Disney World")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#the-bone-marrow-transplant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bone Marrow Transplant")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#going-to-her-heavenly-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going to Her Heavenly Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#our-loss-is-his-gain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Loss Is His Gain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#preparing-for-her-union-with-christ",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing for Her Union With Christ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#death-is-not-the-end",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death Is Not the End")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#thoughts-from-dad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thoughts From Dad")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#litany-in-honor-of-the-little-therese",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Litany in Honor of the Little Therese")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0